/**
 * AutoSaveIndicator - Viser lagringsstatus
 * Shared komponent for alle moduler med autolagring
 */
import { Loader2, Cloud, CloudOff } from 'lucide-react';

export function AutoSaveIndicator({ status }) {
  if (status === 'idle') return null;
  
  return (
    <div className="flex items-center gap-2 text-xs">
      {status === 'saving' && (
        <>
          <Loader2 className="w-3 h-3 animate-spin text-[var(--copper)]" />
          <span className="text-[var(--text-muted)]">Lagrer...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Cloud className="w-3 h-3 text-[var(--success)]" />
          <span className="text-[var(--success)]">Lagret</span>
        </>
      )}
      {status === 'error' && (
        <>
          <CloudOff className="w-3 h-3 text-[var(--error)]" />
          <span className="text-[var(--error)]">Feil</span>
        </>
      )}
    </div>
  );
}

export default AutoSaveIndicator;
